import { CasaHabitacion } from "../casa/model/casa-habitacion.model";
import { VehiculoForm } from "../cotizacion/models/emision.model";
import { PolizaPrimas } from "../funerario/models/emisionVida.model";
import { B2CPortalProductoParametro, ConfiguracionAutos } from "./B2CPortalProductoParametro.model";
import { Contratante } from "./contratante.model";
import { ContratanteDireccion } from "./contratanteDireccion.model";
import { Conductor } from "./data-emision.model";
import { DatosCotizacion } from "./datos-cotizacion.model";
import { Prospecto } from "./prospecto.model";
export class QuattroB2C {
    public m: string = "";
    public tkn: string = "";
    public tknTmp:string = "";
    public socioEnc: string = '';
    public datosCotizacion?: DatosCotizacion;
    public contratante?: Contratante;
    public conductor?:Conductor;
    public paquete?: number = 1;
    public url?:string = "";
    public vehiculo?: VehiculoForm;
    public prospecto?: Prospecto;
    public celular?:string = "";
    public configuracionAutos?: ConfiguracionAutos;
    public origen:number = (window.location.hostname==="nacoseguro.mx"?19:window.location.hostname==="gapper.tupoliza.mx"?26:window.location.hostname==="aycia.tupoliza.mx"?27:
    window.location.hostname==="irpac.tupoliza.mx"?31:window.location.hostname==="buscapolizas.tupoliza.mx"?32:window.location.hostname==="certy.trinitas.mx"?33:window.location.hostname==="keet.tupoliza.mx"?35:
    window.location.hostname==="safenow.tupoliza.mx"?36:(19)); 
    public productoParametros?: B2CPortalProductoParametro;
    public casaHabitacion: CasaHabitacion = new CasaHabitacion();
    public contratanteDireccion?: ContratanteDireccion= new ContratanteDireccion();
    public direccionClienteID?: string;
    public b2cParametros: Array<B2CPortalProductoParametro> = [];
    public b2cProductoIDEnc: string = "";
    public urlNext?: string = "";
    public cotizacionVida?: PolizaPrimas = new PolizaPrimas();
    public b2cPortalID: string = "";
    public portalParametros: B2CPortalProductoParametro[] = [];
    public transaccionIDEnc?:string;
}